import React, { useState } from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';
import { VSpacer, List, Button, Link } from '@mqd/volt-base';
import KycDocumentUploadModal from './KycDocumentUploadModal';

const GET_KYC_DOCUMENTS = gql`
  query kycFiles($cardholder_token: String!) {
    kycFiles(cardholder_token: $cardholder_token) {
      filename
      getUrl
    }
  }
`;

const GET_KYB_DOCUMENTS = gql`
  query kybFiles($cardholder_token: String!) {
    kybFiles(cardholder_token: $cardholder_token) {
      filename
      getUrl
    }
  }
`;


const KycDocumentsTab = ({ cardholderToken, type }) => {
  const [isUploadModalVisible, setIsUploadModalVisible] = useState(false);
  const { data, loading, refetch, error } = useQuery(type === 'kyb' ? GET_KYB_DOCUMENTS : GET_KYC_DOCUMENTS, {
    fetchPolicy: 'network-only',
    variables: {
      cardholder_token: cardholderToken
    }
  });
  
  // Extract KYC documents from the API response
  const kycDocuments = data?.kycFiles || data?.kybFiles || [];

  // Map the KYC documents to the format required by the List component
  const documentRows = kycDocuments.map(document => ({
    name: document.filename,
    downloadLink: document.getUrl
  }));

  const columns = [
    {
      id: 'name',
      label: 'Document Name',
      sort: true,
      width: 300,
    },
    {
      id: 'downloadLink',
      label: 'Action',
      renderer: ({ val }) => (
        <Link href={val} newTab={true}>View document</Link>
      ),
      sort: false,
      width: 150
    }
  ];

  const emptyStateProps = {
    text: 'No Documents Available',
    subText: 'There are no documents available for this profile.'
  };

  const handleUploadSuccess = (filename) => {
    console.log('Upload successful:', filename);
    // Refetch the documents list to show the new upload
    refetch();
  };

  const handleUploadError = (error) => {
    console.error('Upload failed:', error);
    // You could show a toast notification or alert here
  };

  return (
    <div>
      {error && (
        <div style={{
          padding: '16px',
          backgroundColor: '#ffeaea',
          borderRadius: '4px',
          border: '1px solid #ff6b6b',
          marginBottom: '16px'
        }}>
          <div style={{ color: '#d63031', fontWeight: 'bold', marginBottom: '8px' }}>
            Error Loading Documents
          </div>
          <div style={{ color: '#d63031' }}>
            {error?.message || 'Failed to load documents. Please try again.'}
          </div>
        </div>
      )}
      
      <List
        columns={columns}
        rows={documentRows}
        loading={loading}
        cellOverflowEllipsis={true}
        onRowClick={({ e, row, rowIndex }) => {
          console.log('Row clicked:', row, 'at index:', rowIndex);
          // Handle row click action here
        }}
        emptyStateProps={emptyStateProps}
      />
      <VSpacer factor={3} />

      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '16px' }}>
        <Button
          mod="primary"
          onClick={() => setIsUploadModalVisible(true)}
          testId="upload-kyc-document-btn"
        >
          Upload document
        </Button>
      </div>
      <VSpacer factor={8} />

      <KycDocumentUploadModal
        isVisible={isUploadModalVisible}
        hideModal={() => setIsUploadModalVisible(false)}
        cardholderToken={cardholderToken}
        onUploadSuccess={handleUploadSuccess}
        onUploadError={handleUploadError}
        type={type}
      />
    </div>
  );
};

KycDocumentsTab.propTypes = {
  cardholderToken: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['kyc', 'kyb']).isRequired
};

export default KycDocumentsTab;
